module.exports = __webpack_public_path__ + "3-71.jpg?eae8edc6dcb59bbf8c7c2251117e825a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-71.jpg
// module id = 153
// module chunks = 0